
export enum SystemStatusFilter {

    OPEN        = 'open',   // i.e. open only
    CLOSED      = 'closed',
    ALL         = 'all'

}